// Whether an unlinked student has hit the hard paywall (trial spent or a
// subscription that needs (re)starting). When true the app shows the dedicated
// StudentSubscribePrompt page instead of the feed, so the student can focus on
// resolving billing. Linked students ride a parent's plan and never paywall.
//
// This MUST stay in lockstep with StudentSubscribePrompt's own `isEligible`
// guard: App renders the prompt as a full page when this is true, so any state
// the prompt would self-skip (returning null) must be false here too, or the
// student gets a blank page. Trial expiry sets the action to `create_new`, so
// the action check already covers the spent-trial case.
// See docs/design-subscription-trial-ownership.md.
export function isStudentPaywalled({ isLinked, subscriptionAction }) {
    if (isLinked) return false;
    const action = subscriptionAction?.action;
    return action === 'create_new' || action === 'create_new_has_canceled';
}
